export default __webpack_public_path__ + "static/media/risk_level_no.a69483df.png";